export const Color = {
    black: "#000000",
    main: '#FC6200',
    darkMain: '#000000',
    secondary: '#FFCC00',
    base01: '#ffffff',
    base02: '#f1f1f1',
    base03: '#4a4a4a',
    base04: '#7d7d7d',
    base05: '#0c0c0c',
    base06: '#0294f6',
    base07: '#e91515',
    base08: '#171717',
    base09: '#171717',
    base10: "#232323",
    base11: '#303030',
    transparent: 'transparent'
}